import { useEffect, useState } from 'react';
import { API_BASE } from './api-base';
import { EMAIL_PREVIEW_WIDGET_SPEC, toggleOverride } from './dev-feature-toggles';

const GATE_TIMEOUT_MS = 1500;

let cached: Promise<boolean> | null = null;

export function emailPreviewWidgetEnabled(): Promise<boolean> {
  const forced = toggleOverride(EMAIL_PREVIEW_WIDGET_SPEC);
  if (forced !== undefined) return Promise.resolve(forced === 'true');
  if (cached) return cached;
  cached = (async () => {
    try {
      const res = await fetch(`${API_BASE}/api/flags/email-preview-widget`, {
        credentials: 'include',
        signal: AbortSignal.timeout(GATE_TIMEOUT_MS),
      });
      if (!res.ok) {
        cached = null;
        return false;
      }
      return ((await res.json()) as boolean) === true;
    } catch {
      cached = null;
      return false;
    }
  })();
  return cached;
}

export function useEmailPreviewWidgetEnabled(): boolean | undefined {
  const [enabled, setEnabled] = useState<boolean | undefined>(undefined);
  useEffect(() => {
    let live = true;
    void emailPreviewWidgetEnabled().then((on) => {
      if (live) setEnabled(on);
    });
    return () => {
      live = false;
    };
  }, []);
  return enabled;
}
